import logger from "@/utils/logger";

export default async function getCategoryTreeClient(mpId: number): Promise<CategoryTree[] | null> {
  try {
    const res = await fetch(
      `/rest/neo/pdp/${mpId}/categories-tree?culture=en_US&verId=${process.env.NEXT_PUBLIC_VERTICAL_ID}`,
      {
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        next: { revalidate: 300 }, // 5 minutes
      },
    );
    const response = (await res.json()) as CategoryTree[];

    if (response) {
      return response;
    } else {
      return null;
    }
  } catch (error) {
    logger.error(error);
    return null;
  }
}
